















































import { detailedDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { ISignDocument } from "@/models/sign-document.entity";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SignDocumentSideCard from "../sign-document/SignDocumentSideCard.vue";
import TimelineCard from "../utility/TimelineItem.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import ActivityTimeLineItemDocumentCardImages from "./ActivityTimeLineItemDocumentCardImages.vue";
import { IDownloadFile } from "../utility/interface/download-file.interface";
import FileDownload from "../utility/FileDownload.vue";
import ContextMenu from "../utility/ContextMenu.vue";

@Component({
  components: {
    TimelineCard,
    ActivityTimeLineItemDocumentCardImages,
    ActivityTimeLineItemDelete,
    SignDocumentSideCard,
    FileDownload,
    ContextMenu
  }
})
export default class ActivityTimeLineItemDocumentCard extends mixins(DarkModeHighlightMixin, PermissionMixin) {
  @Prop({ default: false })
  isLoading!: boolean;

  @Prop()
  document!: ISignDocument;

  @Prop()
  name?: string;

  @Prop()
  created?: string;

  @Prop()
  activityLogEntry?: IActivityLog;

  @Prop()
  source?: MrfiktivReferenceGen;

  openSideCard = false;

  get date() {
    if (this.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(this.created, locale);
    }
    return "Kein Datum";
  }

  get title() {
    if (this.name && this.date) {
      return this.$t("timeLine.ActivityTimeLineItemDocument.title", { name: this.name, date: this.date });
    } else {
      return this.$t("timeLine.ActivityTimeLineItemDocument.sharedDocument");
    }
  }

  get downloadFile(): IDownloadFile {
    return {
      filename: this.document.name,
      url: this.document.url
    };
  }

  goToDetail() {
    this.document?.goTo(this.$router).detail();
  }
}
